import {StyleSheet} from 'aphrodite';

const styles = StyleSheet.create({
    locateButtonOnTheRight: {
        float: 'right',
    },
});

export default styles;
